import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import DonationBar from './components/DonationBar';
import About from './components/About';
import Impact from './components/Impact';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  const [donationGoal] = useState(2500000);
  const [currentDonations, setCurrentDonations] = useState(1625000);

  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <DonationBar 
        goal={donationGoal} 
        current={currentDonations}
        onDonate={(amount) => setCurrentDonations(prev => prev + amount)}
      />
      <Impact />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;